export const PACING_TEXT = {
  self_paced: "Self-Paced",
  instructor_paced: "Instructor-Paced",
};
